import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

type Props = {
	/** The child's own, unscaled size. */
	width: number;
	height: number;
	scale: number;
	style?: StyleProp<ViewStyle>;
	children: React.ReactNode;
};

/**
 * Draws a fixed-size component at another size without touching it: the child keeps laying
 * itself out at `width` x `height` and is transformed by `scale`, while this box takes the
 * scaled size in the layout around it. A transform alone leaves the unscaled box behind, so
 * neighbours would be placed as if nothing had grown.
 *
 * Meant for the desktop layer, which draws several mobile header pieces - the wallet, the
 * avatar, the top-bar buttons, the missions and free-chips pills - at the desktop frame's
 * size: they are the same components as the mobile ones, only bigger.
 */
export const ScaledBox = ({ width, height, scale, style, children }: Props) => (
	<View style={[{ width: width * scale, height: height * scale }, style]}>
		<View
			style={{
				position: 'absolute',
				width,
				height,
				// Scaling happens about the centre, so the child is placed where its centre has to
				// end up: the middle of the scaled box.
				left: (width * scale - width) / 2,
				top: (height * scale - height) / 2,
				transform: [{ scale }],
			}}
		>
			{children}
		</View>
	</View>
);

export default ScaledBox;
